<div class="workspace">
  <div class="row post-overview-container">
    <div class="col-md-12 col-lg-4 post-overview-container-left d-none d-sm-block">
      <div class="row basic-info">
        <div class="col-sm-2 back-button-container">
          <div class="d-flex flex-row justify-content-start">
            <div class="back-btn d-flex justify-content-center align-items-center" *ngIf="!hideBackButton && !onInfluencerPlatform" (click)="back()" >
              <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <defs></defs>
                <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Arrow/Left" transform="translate(-12.000000, -4.000000)" fill="#000000">
                    <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="col-sm-10 influencer-basic-info-container">
          <div class="influencer-basic-info">
            <achoo-placeholder [facebookPlaceholder]="true"
                               [normalPlaceholder]="false"
                               [placeholderId]="'influencerBasicInformation'">
              <app-influencer-basic-information
                [influencer]="influencer"
                [supportIgStoryLoader]="false"
                [showCountryFlagIcon]="showCountryFlagIcon"
                [allowRedirectToInfluencerPage]="true"
                [enableForMediaPlatform]="!onInfluencerPlatform">
              </app-influencer-basic-information>
            </achoo-placeholder>
          </div>
          <div class="influencer-note-list" *ngIf="postContent && !onInfluencerPlatform">
            <add-notes [influencerId]="postContent.influencerId"></add-notes>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-lg-8 post-overview-container-right">
      <div class="row post-details" *ngIf="postContent">
        <div class="col-md-12 post-details-title d-none d-sm-block">
          <div class="d-flex flex-g1 breadcumb-container">
            <div class="d-flex flex-column full-width">
              <div class="flex-g1 breadcumb-header">
                <div class="d-flex flex-row flex-wrap">
                  <div class="d-flex flex-row align-items-center">
                    <a class="not-underline first-line text-capitalize">{{'page.post_overview.header' | translate}}</a>
                    <img src="assets/images/Arrow_Right.svg" class="breadcrumb-arrow"/>
                  </div>
                  <div class="d-flex flex-row align-items-center flex-auto post-title-container">
                    <span class="text-light-font post-title" title="{{postContent.title}}">{{postContent.title}}</span>
                  </div>
                </div>
              </div>
              <div class="flex-g1 breadcumb-subheader post-published-date">
                <span>{{postContent.publishedDate | date: 'd MMMM yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 post-published-date d-block d-sm-none" *ngIf="true">
          <span>Date: {{postContent.publishedDate | date: 'd-MM-yyyy'}}</span>
        </div>

        <div class="col-md-12 post-details-content">
          <div class="d-flex flex-g1 post-activity-line-chart">
            <div class="d-flex flex-g1 content-shadow-box full-width" *ngIf="postActivityLineChartData && !true">
              <div class="d-flex flex-g1 flex-column full-width">
                <div class="post-details-section-title post-activity-line-chart-title">
                  <span class="text-uppercase">{{'page.post_overview.section_title.engagement' | translate}}</span>
                </div>
                <div class="post-activity-line-chart-body">
                  <achoo-line-chart
                    [chartData]="postActivityLineChartData"
                    [legendXPosition]="30"
                    [legendYPosition]="-5"
                    [legendItemDistance]="1"
                    [xLabelPaddingTop]="15"
                    [spacingBottom]="10"
                    [fallbackMsg]="'page.post_overview.daily_kpi_fallback_msg' | translate"
                  ></achoo-line-chart>
                </div>
              </div>
            </div>


            <div class="d-flex flex-g1 content-shadow-box full-width" *ngIf="postContent && true">
              <div class="d-flex flex-column flex-g1">
                <div class="post-details-section-title d-none d-sm-block">
                  <span class="text-uppercase">{{'page.post_overview.section_title.post' | translate}}</span>
                </div>
                <div class="post-details-section-body">
                  <post-content
                    [postContent]="postContent"
                    [postMentions]="postContent.mentions"
                    [postSponsors]="postContent.sponsors"
                    [platformIconUrl]="platformIconUrl"
                  ></post-content>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 post-details-content post-kpis-section" *ngIf="postKpi">
          <div class="d-flex flex-g1">
            <kpi-report
              [kpi]="postKpi"
              [showKpiStatus]="false"
            ></kpi-report>
          </div>
        </div>
        <div class="col-md-12 post-details-content post-content-section" *ngIf="postContent && !true">
          <div class="flex-g1">
            <div class="content-shadow-box">
              <div class="d-flex flex-column">
                <div class="post-details-section-title">
                  <span class="text-uppercase">{{'page.post_overview.section_title.post' | translate}}</span>
                </div>
                <div class="post-details-section-body">
                  <post-content
                    [postContent]="postContent"
                    [postMentions]="postContent.mentions"
                    [platformIconUrl]="platformIconUrl"
                  ></post-content>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 post-details-content post-activity-chart-section" *ngIf="postActivityLineChartData && true">
          <div class="flex-g1">
            <div class="d-flex flex-g1 content-shadow-box high-chart full-width">
              <div class="d-flex flex-g1 flex-column full-width">
                <div class="post-details-section-title post-activity-line-chart-title">
                  <span class="text-uppercase">{{'page.post_overview.section_title.engagement' | translate}}</span>
                </div>
                <div class="post-activity-line-chart-body">
                  <achoo-line-chart
                    [chartData]="postActivityLineChartData"
                    [legendXPosition]="30"
                    [legendYPosition]="-5"
                    [legendItemDistance]="1"
                    [xLabelPaddingTop]="15"
                    [spacingBottom]="10"
                    [fallbackMsg]="'page.post_overview.daily_kpi_fallback_msg' | translate"
                  ></achoo-line-chart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 margin-top-medium post-details-content d-none d-sm-block" *ngIf="postActivityGaugeChartData || postContent">
          <div class="row post-details-content">
            <div class="col-md-6 post-activity-gauge-chart">
              <div class="chart-container">
                <div class="row">
                  <div class="col-md-12 post-activity-gauge-chart-body">
                    <achoo-pie-chart *ngIf="postActivityGaugeChartData"
                                     [chartData]="postActivityGaugeChartData"
                                     [chartTitle]="'page.post_overview.section_title.engagements' | translate"
                                     [height]="250"
                                     [chartConfig]="enagagementChartConfig"
                                     [forPayingUser]="true"
                                     [listLegendPlaceholder]="['View', 'Like', 'Share', 'Dislike', 'Comment', 'Replies', 'Taps Back', 'Taps Forward', 'Exits']"
                                     [fallbackMsg]="enagagementFallbackMessage"
                                     [fallbackTitle]="enagagementFallbackTitle"
                                     [legend]="pieLegend">
                    </achoo-pie-chart>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 same-influencer-top-5-posts" *ngIf="postContent">
              <div class="content-shadow-box">
                <div class="row">
                  <div class="col-md-12 post-details-section-title top-5-posts-title">
                    <span class="text-uppercase">{{'page.post_overview.section_title.top_posts' | translate}}</span>
                  </div>
                  <div class="col-md-12 top-5-posts-body">
                    <same-influencer-top-five-posts
                      [influencerId]="postContent.influencerId"
                      [urlHash]="postContent.urlHash"
                      [numberOfPosts]="6"
                      [currentPost]="postContent"
                      [onlyForPaidUser]="true"
                    ></same-influencer-top-five-posts>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="message-popup freemium" *ngIf="shouldShowFreemiumFallbackMessage">
            <div class="title">{{fallbackTitle}}</div>
            <div class="sub-title">{{fallbackMessage}}</div>
          </div>
        </div>
        <div class="col-md-12 margin-top-medium post-details-content related-posts-section d-none d-sm-block" *ngIf="topExposures">
          <div class="d-flex flex-g1">
            <div class="d-flex flex-column flex-auto content-shadow-box">
              <div class="d-flex flex-row post-details-section-title related-posts-title">
                <span class="text-uppercase">{{'page.post_overview.section_title.related_posts' | translate}}</span>
              </div>
              <top-exposures [platformList]="platforms"
                             [topExposures]="topExposures" >
              </top-exposures>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="bottombar"
     [ngClass]="{'open': activeBottomBar === true, 'collapsed': activeBottomBar === false}">
  <div class="row full-height">
    <div class="col-md-12 buttons-manage align-items-end" *ngIf="!activeBottomBar">
      <div class="buttons d-flex flex-auto justify-content-end" *ngIf="!onInfluencerPlatform">
        <button class="button gray"
                [popper]="postMoreFunctionPopper"
                [popperTrigger]="'click'"
                [popperDisableAnimation]="true"
                [popperApplyClass]="'ngx-popper, grey'"
                [popperApplyArrowClass]="'ngx-popper-arrow'"
                [popperPlacement]="'bottom'">
          {{'common.btn.more' | translate}}
        </button>
        <popper-content #postMoreFunctionPopper>
          <ul class="funtion-menu">
            <li>
              <button class="button gray"
                      actionByLevels="Branded Exports"
                      [wallName]="'Reports Disabled'"
                      (afterChecking)="exportPDF(postMoreFunctionPopper)">
                {{'common.btn.download_as_pdf' | translate}}
              </button>
            </li>
          </ul>
        </popper-content>
        <button class="button blue"
                actionByLevels="Add to campaign"
                [wallName]="'Campaigns Disabled'"
                [actionData]="actionData('campaign')"
                (afterChecking)="showAddToCampaign()">
          {{'common.btn.add_to_compaign' | translate}}
        </button>
        <button class="button green"
                actionByLevels="Add to group"
                [wallName]="'Add to project'"
                [actionData]="actionData('project')"
                (afterChecking)="showAddToProject()">
          {{'common.btn.add_to_project' | translate}}
       </button>
      </div>
      <div class="buttons d-flex flex-auto justify-content-end" *ngIf="onInfluencerPlatform">
        <button class="button red" (click)="back()">
          {{'common.btn.back' | translate}}
        </button>
      </div>
    </div>
    <div class="col-md-12 col-sm-12">
      <add-influencers-to-campaign *ngIf="isEnableAddToCampaign === true"
                                   (addToCampaignExecution)="addInfluencerToCampaign($event)"
                                   (backToPreviewInfluencerEvent)="hideBottomBar()"
                                   [selectedCampaign]="selectedCampaign"
                                   [campaignList]="campaignList">
      </add-influencers-to-campaign>
      <add-posts-to-project *ngIf="isEnableAddToProject === true"
                             (addPostsToProjectExecution)="addPostIntoProject($event)"
                             (backToPreviewInfluencerEvent)="hideBottomBar()"
                             (createNewProjectEvent)="showCreateProjectFragement()"
                             [isShowSummarize]="true"
                             [activePage]="activePage"
                             [projectList]="projectList" >
      </add-posts-to-project>

      <edit-project *ngIf="showCreateNewProjectFragment"
                     [activePage]="activePage"
                     [project]="newProject"
                     [countryList]="countryList"
                     (closeBottomBarCallback)="afterCreateProjectSuccess($event)">
      </edit-project>
    </div>
  </div>
</div>

<achoo-popup #AlertAddPostToCampaignSuccess
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (cancelCallback)="hideAlertSuccess()">
  <span>{{'discover.add_post_to_campaign_success' | translate:{selected_campaign: selectedCampaignNotificationMsg} }}</span>
</achoo-popup>
<achoo-popup #AlertAddPostToCampaignError
             [isNotification]="true"
             modelTitle="{{'notification.error' | translate}}"
             (cancelCallback)="hideAlertSuccess()">
  <span>{{'discover.add_post_to_campaign_error' | translate:{selected_campaign: selectedCampaignNotificationMsg} }}</span>
</achoo-popup>
<achoo-popup #NotificationAfterAddPostToProject
             [isNotification]="true"
             modelTitle="{{'notification.success' | translate}}"
             (cancelCallback)="hideAlertSuccess()">
  <span>{{'discover.notification_after_add_post_to_project' | translate:{projectName: projectName} }}</span>
</achoo-popup>
<achoo-popup #AlertPdfDownloadPending
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}"
             (acceptCallback)="hideAlertSuccess()"
             (cancelCallback)="hideAlertSuccess()">
  <span>{{'pdf.pending_message' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-overview.component.html